import { css, styled } from 'styled-components';

import { layoutHeaderMobileLinksHeight } from '#/layouts/Layout/Header/layoutHeaderConstants';
import { scrolledDownZeroVar } from '#/theme/scrolled';
import { colors, cssBreakpoints, gutterWidth, transition } from '#/theme/theme';

type LayoutHeaderSearchSubmenuHolderProps = {
  $hideMobileHeaderOnScroll: boolean;
  $withScrolledTransition: boolean;
  /** Hamburger menu enabled: the Header Links row is hidden at mdDown */
  $hideMobileLinks: boolean;
};

// The mobile Header Links row is absolutely positioned below the top section,
// so the submenu has to reserve its height
function mobileLinksPaddingTopCss(props: LayoutHeaderSearchSubmenuHolderProps) {
  if (props.$hideMobileLinks) {
    return css`
      padding-top: 0;
    `;
  }

  if (props.$hideMobileHeaderOnScroll) {
    return css`
      transition: ${props.$withScrolledTransition &&
      `padding-top ${transition}`};
      padding-top: calc(
        ${[layoutHeaderMobileLinksHeight]}px * var(${scrolledDownZeroVar}, 1)
      );
    `;
  }

  return css`
    padding-top: ${layoutHeaderMobileLinksHeight}px;
  `;
}

export const LayoutHeaderSearchSubmenuHolder = styled.div<LayoutHeaderSearchSubmenuHolderProps>`
  display: flex;
  flex-direction: column;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    ${mobileLinksPaddingTopCss};
  }
`;

export const LayoutHeaderDesktopSearchHolder = styled.div`
  padding: 16px ${gutterWidth / 2}px;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.selectionGrey};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
